import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/noticeBoard/jobCircular.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const JobCircular = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Job Circular`;
  }, []);

  const shareUrl = "https://ashroyangon.org/noticeBoard/job-circular";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="job_circular_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Job Circular</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="job_circular_wrapper">
          <div className="container">
            <h2>Job Circular</h2>
            <div className="single_circular">
              <div className="icon_and_status">
                <FontAwesomeIcon
                  className="warning"
                  icon={faTriangleExclamation}
                />
                <p>Expired</p>
              </div>
              <h3>Circular for Upcoming Project</h3>
              <button className="link_button">
                <Link to="/we-are-hiring/upcoming-project">Click the Details</Link>
              </button>
            </div>

            <div className="single_circular">
              <div className="icon_and_status">
                <FontAwesomeIcon
                  className="warning"
                  icon={faTriangleExclamation}
                />
                <p>Expired</p>
              </div>
              <h3>Circular for BBC Media Project</h3>
              <button className="link_button">
                <Link to="/we-are-hiring/upcoming-project">Click the Details</Link>
              </button>
            </div>

            <div className="single_circular">
              <div className="icon_and_status">
                <FontAwesomeIcon
                  className="warning"
                  icon={faTriangleExclamation}
                />
                <p>Expired</p>
              </div>
              <h3>Circular for Earn Project</h3>
              <button className="link_button">
                <Link to="/we-are-hiring/earn-project">Click the Details</Link>
              </button>
            </div>

            <div className="single_circular">
              <div className="icon_and_status">
                <FontAwesomeIcon
                  className="warning"
                  icon={faTriangleExclamation}
                />
                <p>Expired</p>
              </div>
              <h3>Circular for Ain Shohayota Activity Project</h3>
              <button className="link_button">
                <Link to="/we-are-hiring/ain-shohayota-activity">Click the Details</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JobCircular;
